import React from "react";
import { formatDateShort } from "./helpers";

/**
 * Transforms a single installed store item for table display
 * @param {Object} store - Store object from API
 * @param {number} index - Index for serial number
 * @param {Function} formatDate - Date formatting function
 * @returns {Object} Transformed store object
 */
export const transformInstalledStoreItem = (store, index, formatDate = formatDateShort) => ({
    sn: index + 1,
    store_name: store.store_name,
    store_domain: store.store_domain,
    plan: store.plan,
    created: formatDate(store.created_at),
    status: store?.is_active && store?.install_status === 3
        ? <span className="btn btn-primary btn-sm">ACTIVE</span>
        : <span className="btn btn-danger btn-sm">INACTIVE</span>,
    trial: store?.is_trial ? 'Trial' : 'Not Trial',
});

/**
 * Transforms array of installed stores into DataTable format
 * @param {Array} stores - Array of store objects from API
 * @param {Array} columns - Table column configuration
 * @param {Function} formatDate - Date formatting function (optional)
 * @returns {Object} DataTable formatted object with columns and rows
 */
export const transformInstalledStoresToTableData = (stores, columns, formatDate = formatDateShort) => {
    const rows = stores.map((store, index) => transformInstalledStoreItem(store, index, formatDate));

    return {
        columns,
        rows
    };
};

